import React from "react";
import { Box, Button, Dialog, DialogContent, Stack, Typography, alpha } from "@mui/material";

export default function AddBranchDialog({ open, onClose, parentLabel, branches, onPick }) {
    const title = parentLabel ? `Add branches under “${parentLabel}”` : "Add branches under this plan";

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: (theme) => ({
                    bgcolor: theme.palette.mode === "dark" ? "#0d0d0d" : theme.palette.background.paper,
                    backgroundImage: "none",
                    border: 1,
                    borderColor: "divider",
                }),
            }}
        >
            <Box sx={{ px: 3, pt: 2.5, pb: 1, display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                <Box>
                    <Typography variant="overline" sx={{ color: "success.main", fontWeight: 800, letterSpacing: "0.2em" }}>
                        ADD
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, mt: 0.5 }}>
                        {title}
                    </Typography>
                </Box>
                <Button onClick={onClose} variant="outlined" size="small" sx={{ fontWeight: 700, letterSpacing: "0.08em" }}>
                    CLOSE
                </Button>
            </Box>

            <DialogContent sx={{ px: 3, pb: 3 }}>
                {!branches?.length ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                        No more branch templates at this level.
                    </Typography>
                ) : (
                    <Stack spacing={1.25}>
                        {branches.map((branch) => (
                            <Box
                                key={branch.group_key}
                                component="button"
                                type="button"
                                onClick={() => {
                                    onPick?.(branch);
                                    onClose();
                                }}
                                sx={(theme) => ({
                                    display: "block",
                                    width: "100%",
                                    textAlign: "left",
                                    cursor: "pointer",
                                    border: 1,
                                    borderColor: alpha(theme.palette.divider, 0.9),
                                    bgcolor: "transparent",
                                    color: "inherit",
                                    px: 2,
                                    py: 1.75,
                                    "&:hover": {
                                        borderColor: "primary.main",
                                        bgcolor: alpha(theme.palette.primary.main, 0.06),
                                    },
                                })}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.35 }}>
                                    {branch.label}
                                    {branch.is_bundle === 1 || branch.is_bundle === true ? (
                                        <Typography component="span" variant="caption" color="success.main" sx={{ ml: 1 }}>
                                            bundle
                                        </Typography>
                                    ) : null}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {branch.description || "Add just this branch, then nest more under it."}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                )}
            </DialogContent>
        </Dialog>
    );
}
